<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Create Call Log'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="getPrimaryLabel"
        :secondaryLabel="getSecondaryLabel"
        v-if="loaded"
      />
    </template>

    <div class="create-call-log css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="model"
          :itemSaveCallBack="checkHeaderFormValidation"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div class="header-form-container">
        <div class="header-form-1">
          <div class="view-card responsive-paddings">
            <gc-form
              :formOptions="{
                gcLabelLocation: 'left',
              }"
              :formItems="getHeaderFormItems"
              :isNormal="true"
              :data-model="model"
              :formContentReady="formContentReady"
              :formMode="baseView.mode"
              :fromFrom="'gc-header-form'"
              ref="gc-header-form"
              :valueChangeCallBack="headerFormValueChanged"
              :checkValid="isValid"
              :validationGroup="'gc-header-form'"
              :scrollingEnabled="false"
              :formHeight="100"
            ></gc-form>
          </div>
        </div>
      </div>

      <div class="notes-container">
        <div class="heading">
          <span> <h4>Notes</h4></span>
          <DxButton
            :icon="'plus'"
            class="add-new-btn"
            :text="'Add New'"
            type="default"
            @click="addMoreNotes"
            :visible="baseView.mode != 'review'"
          />
        </div>
        <hr />

        <!-- <DxScrollView
          id="scrollview"
          :direction="'horizontal'"
          :scroll-by-content="true"
          :scroll-by-thumb="true"
          :show-scrollbar="'always'"
          :height="200"
        > -->
        <div
          class="notes"
          v-bind:style="{
            'max-height': scrollViewHeight + 'px',
          }"
        >
          <div
            class="note"
            v-for="(item, index) in NumOfNotes"
            v-bind:key="index"
          >
            <div>
              <div class="toolbar">
                <span>Note</span>

                <DxTextArea
                  :element-attr="{ id: 'note-' + index, class: 'notes-text' }"
                  height="50"
                  width="100%"
                  :auto-resize-enabled="true"
                  :value="item.Note"
                  @value-changed="onNoteValueChanged($event, item)"
                  @initialized="onNoteFieldInitialized"
                  @keyDown="onNoteKeyDown($event, index)"
                  :read-only="baseView.mode == 'review'"
                  :ref="'note-text-ares-' + index"
                />
                <DxButton
                  :icon="'trash'"
                  class="delete-btn"
                  @click="deleteNote(index)"
                  :visible="baseView.mode != 'review'"
                  :tabIndex="-1"
                />
              </div>

              <div class="notes-content">
                <div class="uploader">
                  <DxFileUploader
                    select-button-text="Upload"
                    label-text=""
                    accept="image/*"
                    upload-mode="useForm"
                    :show-file-list="false"
                    :multiple="true"
                    @value-changed="onImageUploaded($event, item)"
                    :visible="baseView.mode != 'review'"
                    :tabIndex="-1"
                  />
                </div>

                <div
                  class="thumbnail-container"
                  v-if="item.imageSrcs.length > 0"
                >
                  <img
                    v-for="(img, x) in item.imageSrcs"
                    v-bind:key="x"
                    :src="img.src"
                    alt="Company Logo"
                    height="200"
                    width="200"
                    @click="previewThumbnail(img, item)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </DxScrollView> -->

        <GcPopupImagePreview
          :previewVisible="previewVisible"
          :onBackButtonClick="() => (previewVisible = false)"
          :dataModel="imgDataModel"
          :allow-download="baseView.mode != 'create'"
          :allow-remove="baseView.mode != 'review'"
          :onRemoveImage="onRemoveImage"
        />
      </div>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import validationEngine from "devextreme/ui/validation_engine";

import { CustomerCallLogsService } from "../../_services/api/customers/customer-call-logs.service";
import { CallTypeService } from "../../_services/api/customers/call-type.service";
import { FeatureStorage } from "../../_services/storage";
import { CacheService } from "../../_services/cache/cache-service";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";

import resizeImage from "../../_helpers/image-processing/resizeImage.js";
import appConfig from "../../app-config";
import { CustomerSurveysResponseService } from "../../_services/api/customers/customer-surveys-response.service";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {},
  data() {
    return {
      loaded: false,
      previewVisible: false,
      isValid: false,
      model: {
        Status: undefined,
        CustomerCode: undefined,
        CallLogCallTypeCode: undefined,
        StartCall: new Date(),
        EndCall: undefined,
        Duration: "0 Mins",
        CallPurpose: undefined,
        ActualDuration: 0,
        CalendarScheduleRecordID: undefined,
      },
      NumOfNotes: [],
      previewImg: undefined,
      imgDataModel: {},
      customerName: "",
      backButtonRoute: "/call-logs",
      scrollViewHeight: undefined,
      addNewNote: false,
      CustomerSalesRepresentativeCode: undefined,
      CustomerSurveyResponsesAvailable: false,
    };
  },

  async created() {},
  async mounted() {
    this.initialized();
  },
  beforeDestroy() {},
  computed: {
    getPrimaryLabel() {
      if (this.baseView.mode == "create") return `Create Call Log`;
      else {
        return "Call Log for " + this.customerName;
      }
    },
    getSecondaryLabel() {
      if (this.baseView.mode == "create") return undefined;
      else {
        return new Date(this.model.StartCall).toShortDateString();
      }
    },
    getHeaderToolbar() {
      return {
        audit: true,
        status: true,
        notes: false,
        save: FeatureStorage.checkPermission("CallLogs", "create"),
        editURL: "/call-logs",
        // editCallBack: this.editSOCallBack,
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // // disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // disabled: true,
                },
              },
            ],
          },
        ],
      };
    },
    getCustomerRepDefault() {
      if (this.CustomerSalesRepresentativeCode)
        return this.CustomerSalesRepresentativeCode;
      else return false;
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  screenField:
                    this.baseView.mode == "review" ? undefined : "Customer",
                  label: {
                    text: "Customer",
                  },
                  dataField:
                    this.baseView.mode == "review"
                      ? "CustomerName"
                      : "CustomerCode",
                  required: true,
                  editorOptions: {
                    tabIndex: 1,
                    onValueChanged: this.onCustomerValueChanged.bind(this),
                  },
                  touchEnabled: this.isTablet,
                  touchModalOptions: {
                    salesrep: true,
                    getUserDefaultRep: this.getCustomerRepDefault,
                  },
                },
                {
                  screenField:
                    this.baseView.mode == "review" ? undefined : "CallType",
                  label: {
                    text: "Type",
                  },
                  dataField:
                    this.baseView.mode == "review"
                      ? "CallLogCallTypeDescription"
                      : "CallLogCallTypeCode",
                  required: true,
                  editorOptions: {
                    tabIndex: 2,
                  },
                  touchEnabled: this.isTablet,
                },
                {
                  editorType: "dxButton",
                  label: {
                    visible: false,
                  },
                  editorOptions: {
                    type: "default",
                    text: "Active Surveys",
                    allowUpdate:
                      this.model.CustomerCode && this.getActiveSurveysButton,
                    onClick: async () => {
                      this.gotoCustomerSurveys();
                    },
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              cssClass: "time-group",
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 3,
                  cssClass: "start-call-group",
                  items: [
                    {
                      dataField: "",
                      label: {
                        visible: false,
                      },
                      cssClass: "call-time-btn",
                      editorType: "dxButton",
                      editorOptions: {
                        onClick: async () => {
                          this.setCallStartTime();
                        },
                        text: "Start",
                        type: "default",
                      },
                    },
                    {
                      label: {
                        text: "Start Call",
                        visible: false,
                      },
                      dataField: "StartCall",
                      required: true,
                      editorType: "dxDateBox",
                      cssClass: "start-call-date",
                      editorOptions: {
                        tabIndex: 3,
                        type: "date",
                        displayFormat: "dd MMM yyyy",
                        onValueChanged: this.onStartCallValueChanged,
                      },
                    },
                    {
                      label: {
                        text: "Start Time",
                        visible: false,
                      },
                      dataField: "StartCall",
                      required: true,
                      editorType: "dxDateBox",
                      editorOptions: {
                        tabIndex: 4,
                        type: "time",
                        showClearButton: true,
                        displayFormat: "hh:mm a",
                        onValueChanged: this.onStartCallValueChanged,
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 3,
                  cssClass: "end-call-group",
                  items: [
                    {
                      dataField: "",
                      label: {
                        visible: false,
                      },
                      cssClass: "call-time-btn",
                      editorType: "dxButton",
                      editorOptions: {
                        onClick: async () => {
                          this.setCallEndTime();
                        },
                        text: "End",
                        type: "default",
                      },
                    },
                    {
                      label: {
                        text: "End Call",
                        visible: false,
                      },
                      // required: true,
                      dataField: "EndCall",
                      editorType: "dxDateBox",
                      cssClass: "end-call-date",
                      editorOptions: {
                        tabIndex: 5,
                        type: "date",
                        displayFormat: "dd MMM yyyy",
                        onValueChanged: this.updateCallDuration,
                        min: this.model.StartCall,
                      },
                    },
                    {
                      label: {
                        text: "End Time",
                        visible: false,
                      },
                      dataField: "EndCall",
                      // required: true,
                      editorType: "dxDateBox",
                      editorOptions: {
                        tabIndex: 6,
                        type: "time",
                        showClearButton: true,
                        displayFormat: "hh:mm a",
                        onValueChanged: this.updateCallDuration,
                        min: this.model.StartCall,
                      },
                    },
                  ],
                },

                {
                  label: {
                    text: "Duration",
                  },
                  dataField: "Duration",
                  editorType: "dxTextBox",
                  editorOptions: {
                    readOnly: true,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              //   colSpan: 2,
              cssClass: "last-column",
              items: [
                {
                  label: {
                    text: "Purpose",
                  },
                  dataField: "CallPurpose",
                  editorType: "dxTextArea",
                  cssClass: "CallPurpose",
                  editorOptions: {
                    tabIndex: 7,
                    height: 100,
                    onKeyDown: (e) => {
                      if (e.event.keyCode == 9 && !e.event.shiftKey) {
                        e.event.preventDefault();
                        if (this.$refs["note-text-ares-0"]) {
                          this.$refs["note-text-ares-0"][0].instance.focus();
                        }
                      }
                    },
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    getActiveSurveysButton() {
      return this.CustomerSurveyResponsesAvailable;
    },
  },
  methods: {
    onCustomerValueChanged(e) {
      this.model.CustomerCode = e.value;
      this.checkActiveSurveysForCustomer(e.value);
    },
    async checkActiveSurveysForCustomer(code) {
      this.CustomerSurveyResponsesAvailable = false;
      await CustomerSurveysResponseService.getActiveSurveysForCustomer(
        code
      ).then((res) => {
        if (res.data.value.length > 0)
          this.CustomerSurveyResponsesAvailable = true;
        else this.CustomerSurveyResponsesAvailable = false;
      });
    },
    gotoCustomerSurveys() {
      const routeData = this.$router.resolve({
        path: "/call-schedule-surveys",
        query: {
          CustomerCode: this.model.CustomerCode,
          Date: true,
          Status: ["Active", "Pending"],
        },
      });
      window.open(routeData.href, "_blank");
    },
    setCallStartTime() {
      this.model.StartCall = new Date();
    },
    setCallEndTime() {
      this.model.EndCall = new Date();
    },
    formContentReady(e) {
      if (e && this.baseView.mode == "create" && this.isTablet == false) {
        let customerCodeEditor = e.component
          .instance()
          .getEditor("CustomerCode");
        if (!customerCodeEditor.option("value")) {
          customerCodeEditor.focus();
        }
      }
    },
    onRemoveImage(id) {
      this.NumOfNotes.forEach((element) => {
        element.imageSrcs.forEach((image, index) => {
          if (image.id == id) {
            element.imageSrcs.splice(index, 1);
            return;
          }
        });
      });
    },
    previewThumbnail(img, item) {
      if (img.type != "upload") {
        this.previewImg = item.images.find(
          (x) => x.FileName == img.FileName && x.SizeType == "preview"
        );

        let originalImg = item.images.find(
          (x) => x.FileName == img.FileName && x.SizeType == "original"
        );

        this.imgDataModel = {
          PreviewImageSrc: this.previewImg.ImageUrl,
          OriginalImageBlobName: this.previewImg.BlobName,
          DownloadApiUrl: `${appConfig.VUE_APP_ROOT_API}/api/CallLogImage/${originalImg.BlobName}/download`,
          id: img.id,
        };
      } else {
        this.imgDataModel = {
          PreviewImageSrc: img.src,
          OriginalImageBlobName: undefined,
          id: img.id,
        };
      }

      this.previewVisible = true;
    },
    async onImageUploaded(e, item) {
      if (e.value.length > 0) {
        e.value.forEach(async (element, index) => {
          let img = new Image();
          img.src = window.URL.createObjectURL(element);
          img.onload = async () => {
            var reader = new FileReader();

            // eslint-disable-next-line no-unused-vars
            reader.onload = async function (onloadEvent) {
              let resizedImageStr = resizeImage(img, element.type);

              item.imageSrcs.push({
                src: resizedImageStr,
                type: "upload",
                FileName: element.name,
                ContentType: element.type,
                FileSize: resizedImageStr.length,
                id: element.name + "_" + index,
              });
            };
            await reader.readAsDataURL(element);
          };
        });
      }
    },
    onNoteValueChanged(e, item) {
      item.Note = e.value;
    },
    onNoteFieldInitialized(e) {
      setTimeout(() => {
        if (this.addNewNote) {
          e.component.instance().focus();
          this.addNewNote = false;
        }
      }, 250);
    },
    onNoteKeyDown(e, index) {
      // TabKey
      if (e.event.keyCode == 9 && e.event.shiftKey && index == 0) {
        e.event.preventDefault();

        if (this.$refs["gc-header-form"])
          this.$refs["gc-header-form"].$refs["gc-form-comp"].instance
            .getEditor("CallPurpose")
            .focus();
      }
    },
    async deleteNote(index) {
      let confirmDelete = await this.$confirm(
        "Are you sure you wants to delete this note?",
        "Delete Note"
      );

      if (confirmDelete) this.NumOfNotes.splice(index, 1);

      if (this.NumOfNotes.length == 0)
        this.NumOfNotes.push({
          Note: undefined,
          imageSrcs: [],
        });
    },
    addMoreNotes() {
      this.showLoading(true);
      this.addNewNote = true;
      this.NumOfNotes.push({
        Note: undefined,
        imageSrcs: [],
      });
      setTimeout(() => {
        this.showLoading(false);
      }, 250);
    },
    onStartCallValueChanged() {
      if (new Date(this.model.StartCall) > new Date(this.model.EndCall)) {
        this.model.EndCall = undefined;
        this.Duration = "0 Mins";
      }

      this.updateCallDuration();
    },
    updateCallDuration() {
      if (!this.model.StartCall || !this.model.EndCall) {
        this.model.Duration = 0;
        return;
      }

      if (
        this.model.StartCall.toSaveDateObject() >
        this.model.EndCall.toSaveDateObject()
      ) {
        this.displayValidationErrors(["End date cannot be before Start date."]);

        this.model.EndCall = undefined;
        this.model.Duration = "0 Mins";
        return;
      }

      if (this.model.StartCall > this.model.EndCall) {
        this.model.Duration = "0 Mins";
        return;
      }

      var diff =
        (new Date(this.model.EndCall).getTime() -
          new Date(this.model.StartCall).getTime()) /
        1000;
      diff /= 60;
      var minutes = Math.round(diff);

      this.model.Duration = minutes + " Mins";
      this.model.ActualDuration = minutes;
    },
    async checkHeaderFormValidation() {
      if (this.model.StartCall > this.model.EndCall) {
        this.displayValidationErrors([
          "End date and time cannot be before Start date and time.",
        ]);
        return;
      }

      let headerform = await validationEngine.validateGroup("gc-header-form");

      if (!headerform.isValid)
        this.displayValidationSummary(headerform.brokenRules);
      else {
        var payload = {
          CalendarScheduleRecordID: this.model.CalendarScheduleRecordID
            ? this.model.CalendarScheduleRecordID
            : "00000000-0000-0000-0000-000000000000",
          CallLogCallTypeCode: this.model.CallLogCallTypeCode,
          CallPurpose: this.model.CallPurpose,
          CustomerCode: this.model.CustomerCode,
          EndTime: this.model.EndCall,
          RecordId: this.baseView.id
            ? this.baseView.id
            : "00000000-0000-0000-0000-000000000000",
          StartTime: this.model.StartCall,
          ActualDuration: this.model.ActualDuration,
          Status: "A",
          CallLogNotes: [],
        };

        this.NumOfNotes.forEach((element) => {
          var imgData = [];
          element.imageSrcs.forEach((img) => {
            imgData.push({
              CallLogHeaderRecordID: this.baseView.id
                ? this.baseView.id
                : "00000000-0000-0000-0000-000000000000",
              ContentType: img.ContentType,
              FileName: img.name ? img.name : img.FileName,
              ImageBase64String: img.src,
              RecordId: img.RecordId
                ? img.RecordId
                : "00000000-0000-0000-0000-000000000000",
              FileSize: img.size,
            });
          });

          payload.CallLogNotes.push({
            CallLogHeaderRecordID: this.baseView.id
              ? this.baseView.id
              : "00000000-0000-0000-0000-000000000000",
            CallNote: element.Note,
            RecordId: element.RecordId
              ? element.RecordId
              : "00000000-0000-0000-0000-000000000000",
            CallLogNoteImagesMetas: imgData,
          });
        });

        this.showLoading(true);
        await CustomerCallLogsService.saveCustomerCallLog(payload)
          .then((res) => {
            this.showLoading(false);
            // eslint-disable-next-line
            console.log("CustomerCallLogsService ", res);

            if (res.data) {
              this.setIgnoreRouteChangeConfirmation();
              this.loaded = false;
              this.$router
                .push({
                  path: "/call-logs/review/" + res.data.RecordId,
                })
                .then(() => {
                  this.initialized();
                });
            }
          })
          .catch((error) => {
            this.showLoading(false);

            this.displayServerError(error, "Save Failed");
          });
      }
    },
    headerFormValueChanged(isValid, brokenRules) {
      this.isValid = false;
      if (!isValid) this.displayValidationSummary(brokenRules);
    },
    backButtonFunction() {
      const { from: parentPage } = this.baseView.query;
      let targetPath = "/call-Logs";

      if (parentPage == "customer-call-logs") {
        targetPath = `/customer-call-logs/${this.baseView.query.cus_id}`;
      } else if (parentPage) {
        targetPath = `/${parentPage}`;
      }

      this.$router.push({
        path: targetPath,
      });
    },

    async initialized() {
      this.loaded = false;
      if (this.baseView.mode != "review" && this.isTablet == true) {
        this.setDefaultCustomerRep();
      }
      this.NumOfNotes = [];
      if (this.baseView.mode != "create") {
        this.showLoading(true);
        await CustomerCallLogsService.getByCustomerCallLog({
          filter: this.baseView.id,
          select: [
            "ExpectedDuration",
            "CalendarScheduleRecordID",
            "CallLogCallTypeCode",
            "CallPurpose",
            "ChangedBy",
            "CreatedBy",
            "CustomerCode",
            "DateChanged",
            "DateCreated",
            "EndTime",
            "PlannedDate",
            "RecordId",
            "StartTime",
            "Status",
            "CustomerName",
            "CallLogCallTypeDescription",
          ],
        })
          .then(async (res) => {
            if (res.data.value) {
              var model = {};
              var callLog = res.data.value[0];
              model.ActualDuration = model.Duration = callLog.ExpectedDuration;
              model.Status = callLog.Status;

              model.DateCreated = callLog.DateCreated;
              model.DateChanged = callLog.DateChanged;
              model.CreatedBy = callLog.CreatedBy;
              model.ChangedBy = callLog.ChangedBy;

              if (callLog.StartTime)
                model.StartCall = new Date(callLog.StartTime);
              else model.StartCall = new Date();

              if (callLog.CalendarScheduleRecordID)
                model.CalendarScheduleRecordID =
                  callLog.CalendarScheduleRecordID;

              if (callLog.EndTime) model.EndCall = new Date(callLog.EndTime);
              else model.EndCall = undefined;
              model.CallPurpose = callLog.CallPurpose;

              model.CustomerCode = callLog.CustomerCode;
              model.CallLogCallTypeCode = callLog.CallLogCallTypeCode;

              this.checkActiveSurveysForCustomer(model.CustomerCode);

              this.customerName = model.CustomerName = callLog.CustomerName;
              model.CallLogCallTypeDescription =
                callLog.CallLogCallTypeDescription;

              this.model = { ...model };

              await CustomerCallLogsService.getCallLogNoteByCallLog(
                this.baseView.id
              )
                .then(async (res) => {
                  if (res.data.value.length > 0) {
                    await res.data.value.forEach(async (element) => {
                      await CustomerCallLogsService.getCallLogNoteImagesMetaByCallLogNote(
                        element.RecordId
                      )
                        .then((res) => {
                          if (res.data.value.length > 0) {
                            var imgs = [];
                            res.data.value.forEach((img, index) => {
                              if (
                                img.SizeType == "thumb" &&
                                img.CallLogNoteRecordID == element.RecordId
                              )
                                imgs.push({
                                  src: img.ImageUrl,
                                  ContentType: img.SizeType,
                                  FileName: img.FileName,
                                  RecordId: img.RecordId,
                                  id: img.FileName + "_" + index,
                                });
                            });
                            this.NumOfNotes.push({
                              Note: element.CallNote,
                              RecordId: element.RecordId,
                              images: res.data.value,
                              imageSrcs: imgs,
                            });
                          } else {
                            this.NumOfNotes.push({
                              Note: element.CallNote,
                              RecordId: element.RecordId,
                              imageSrcs: [],
                            });
                          }

                          this.showLoading(false);
                        })
                        .catch((err) => {
                          if (err) this.showLoading(false);
                        });
                    });

                    this.loaded = true;
                  } else {
                    this.showLoading(false);
                    this.loaded = true;
                  }
                })
                .catch((err) => {
                  if (err) this.showLoading(false);
                  this.loaded = true;
                });
            } else {
              this.loaded = true;
              this.showLoading(false);
            }
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.loaded = true;
          });
      } else {
        this.NumOfNotes.push({
          Note: undefined,
          imageSrcs: [],
        });

        this.model.Status = "D";

        if (this.baseView.query) {
          if (this.baseView.query.cus_id)
            this.model.CustomerCode = this.baseView.query.cus_id;
          if (this.baseView.query.from)
            this.backButtonRoute = this.baseView.query.from;
        }

        let defaultCallType = await CallTypeService.getDefaultCallType();
        if (defaultCallType.data.value.length > 0)
          this.model.CallLogCallTypeCode = defaultCallType.data.value[0].Code;

        this.loaded = true;
      }
    },
    async setDefaultCustomerRep() {
      var defaultSalesRep = CacheService.getCache(
        "UserDefaultSalesRepresentative"
      );

      if (!defaultSalesRep) {
        await SalesRepresentativeService.getUserDefaultSalesRepresentative()
          .then((result) => {
            this.setLoading = false;
            if (result.data.value[0].SalesRepresentativeCode != "") {
              this.CustomerSalesRepresentativeCode =
                result.data.value[0].SalesRepresentativeCode;
            }

            CacheService.saveCache(
              "UserDefaultSalesRepresentative",
              result.data.value[0],
              2
            );
          })
          .catch((err) => {
            if (err) {
              this.setLoading = false;
            }
          });
      } else {
        if (defaultSalesRep.SalesRepresentativeCode != "")
          this.CustomerSalesRepresentativeCode =
            defaultSalesRep.SalesRepresentativeCode;
      }
    },
  },
  watch: {
    loaded(val) {
      if (val) {
        setTimeout(() => {
          var scrollableView = document.getElementsByClassName(
            "layout-body dx-scrollview"
          );
          this.scrollViewHeight = scrollableView[0].clientHeight - 235 - 40;
        }, 250);
      }
    },
  },
};
</script>

<style lang="scss">
.create-call-log {
  height: 100%;
  .header-form-container {
    padding-bottom: 10px;

    .CallPurpose {
      > label {
        padding-top: 6px;
      }

      textarea {
        padding-top: 1px !important;
      }
    }

    .start-call-group {
      .start-call-date {
        padding-right: 0px !important;
      }
    }
    .end-call-group {
      .end-call-date {
        padding-right: 0px !important;
      }
    }
  }
  .notes-container {
    background-color: white;

    .heading {
      height: 45px !important;
    }

    hr {
      margin: 0 !important;
    }
    > div:first-child {
      padding: 10px;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    h4 {
      margin: 0 !important;
    }

    .notes {
      overflow-y: auto;
    }

    .note {
      padding: 10px;

      .uploader {
        .dx-fileuploader-wrapper {
          padding: 0 !important;
        }
        .dx-widget.dx-fileuploader {
          height: 100%;
          .dx-fileuploader-input-wrapper {
            height: 100%;
            border: 0px dashed transparent;
            .dx-fileuploader-input-container {
              input {
                padding: 0 !important;
              }
            }
          }
        }
        .dx-button {
          border-radius: 4px;
          background-color: #03a9f4 !important;
          color: #fff;
          display: flex;
          flex-direction: column;
          z-index: 100;
        }
      }

      > div {
        border-style: solid;
        border-color: #e8e8ed;
        border-width: 2px;
        width: 100%;
        padding: 10px;
        border-radius: 2px;
      }

      .toolbar {
        display: inline-flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: row;
        width: 100%;

        > span:first-child {
          padding-top: 4px;
        }

        .notes-text {
          margin-left: 10px;
          textarea {
            padding-top: 0px !important;
          }
        }
      }

      .thumbnail-container {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 8px;

        img {
          margin-right: 10px !important;
          margin-bottom: 10px !important;
          cursor: pointer;
        }
      }
    }
  }

  .start-call-group,
  .end-call-group {
    .dx-item-content.dx-box-item-content.dx-box.dx-widget.dx-collection {
      .dx-item.dx-box-item:first-child {
        max-width: 65px;
        width: 65px;
        .dx-item-content.dx-box-item-content {
          max-width: inherit;
          width: 65px;
          .call-time-btn {
            padding-right: 0px !important;

            .dx-button-content {
              font-size: 10px;
              padding-top: 0 !important;
              padding-bottom: 0 !important;
            }
          }

          .dx-widget.dx-button {
            width: 65px;
          }
        }
      }
    }
    .dx-texteditor-container {
      input {
        height: 32px;
      }
    }
  }
  .last-column,
  .time-group {
    padding-left: 0 !important;
  }
}
</style>
